import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import SuccessRateDetailsLayout
  from 'Views/Page/Content/Templates/InstitutionSuccessRatesTemplate/MainPanel/SuccessRateDetails/SuccessRateDetailsLayout';
import EditAggregatorLayout
  from 'Views/Page/Content/Templates/InstitutionSuccessRatesTemplate/MainPanel/SuccessRateDetails/EditAggregatorLayout';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  successRateDetailsOverrideSet,
} from 'Views/Page/Content/Templates/InstitutionSuccessRatesTemplate/MainPanel/SuccessRateDetails/successRateDetailsOverride';

const styles = (theme) => ({
  root: {
    display: 'flex',
    width: '100%',
  },
  leftSide: {
    width: '100%',
    padding: theme.spacing(4),
  },
  rightSide: {
    width: '100%',
    paddingTop: 80,
  },
});

const SuccessRateDetails = ({
  className,
  classes,
  resource,
}) => {
  const { refreshPageContentCollection, pageContentCollection } = usePageContentContext();

  const [detailsResource, setDetailsResource] = useState();

  useEffect(() => {
    const load = async () => {
      const [res] = await resource.relationship(fr.relationships.financialInstitutionDetails.name).link('related').get();
      setDetailsResource(res);
    };

    load();
  }, []);

  if (!detailsResource) return null;

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <MetaFormInline
        className={classes.leftSide}
        resource={resource}
        layout={SuccessRateDetailsLayout}
        metaOverrideSet={successRateDetailsOverrideSet}
        readonly
      />
      <MetaFormInline
        className={classes.rightSide}
        resource={detailsResource}
        layout={EditAggregatorLayout}
        metaOverrideSet={BaseOverrideNoHidden}
        readonly
        onSubmit={() => refreshPageContentCollection(pageContentCollection)}
      />
    </Box>
  );
};

SuccessRateDetails.defaultProps = {
  className: '',
};

SuccessRateDetails.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.object.isRequired,
};

export default withStyles(styles)(SuccessRateDetails);
